import { EmptyResults, Table } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, Icons, IconsHeader, L4L, L4LHeader, Name, Percent, Revenue, RevenueBar } from './cellComponents'
import EmptySearchField from './EmptySearchField'
import SearchDetailsContainer from './SearchDetailsContainer'

interface Props {
  details: any
  hasFetchError: boolean
  isTyping: boolean
  searchInputValue: string
  selectedIndices: any[]
  showSelectedOnly: boolean
  stores: any[]
  toggleDetails: () => void
  toggleItem: () => void
}

function SearchResults({
  details,
  hasFetchError,
  isTyping,
  searchInputValue,
  selectedIndices,
  showSelectedOnly,
  stores,
  toggleDetails,
  toggleItem,
}: Props) {
  const { t: translate } = useTranslation()

  if (isTyping) {
    return null
  }

  if (stores.length === 0 && searchInputValue.length <= 2) {
    return <EmptySearchField />
  }

  if (hasFetchError || stores.length === 0) {
    return <EmptyResults />
  }

  if (details) {
    return <SearchDetailsContainer />
  }

  const columns = [
    { key: 'name', title: translate('search.table.shop'), CellRender: Name },
    { key: 'revenue', title: translate('search.table.revenue'), CellRender: Revenue },
    { key: 'concept', title: translate('search.table.concept') },
    { key: 'percent', title: translate('search.table.percent'), CellRender: Percent },
    { key: 'isL4L', title: <L4LHeader />, CellRender: L4L },
    { key: 'icons', title: <IconsHeader />, CellRender: Icons },
    { key: 'checkbox', title: '', CellRender: showSelectedOnly ? RevenueBar : Checkbox },
  ]

  return (
    <Table
      tableClassName={showSelectedOnly ? 'selected-only' : ''}
      columns={columns}
      data={stores}
      onRowClick={showSelectedOnly ? toggleDetails : toggleItem}
      selected={selectedIndices}
    />
  )
}

export default SearchResults
